/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelIfuelControl.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/ifuel-control";

export class AutogenModelIfuelControl<RowType extends ModelRow> extends Endpoint<RowType, RowIfuelControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowIfuelControl extends ModelRow<RowIfuelControlFields> {
	constructor(values?: Partial<RowIfuelControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowIfuelControlFields {
	assignee_type: string;
	atm_access: string;
	auto_inquiry: string;
	bin_number: string;
	business_individual: string;
	card_ip_address: string;
	card_ip_url: string;
	card_maint_port: string;
	card_type: string;
	cash_ip_address: string;
	cash_port: string;
	category_update: Date;
	communication_type: string;
	company_id: string;
	contract_update: Date;
	disp_equip_status: string;
	email_1: string;
	email_2: string;
	email_3: string;
	email_4: string;
	enable_misc_product: string;
	expiration_date: string;
	fuel_account_id: string;
	fuel_interface_id: string;
	fuel_subaccount_id: string;
	has_atm_cash: string;
	iday_create_callin: string;
	iday_create_trans: string;
	iday_last_end: Date;
	iday_last_start: Date;
	ifuel_login: string;
	ifuel_password: string;
	include_errors: string;
	info_prompt: string;
	ip_address: string;
	is_active: string;
	last_emp_no: string;
	log_level: number;
	notify_users: string;
	order_setting: string;
	order_validate: string;
	payroll_settlement: string;
	pin_setting: string;
	pin_validate: string;
	plus_less_flag: string;
	po_setting: string;
	po_validate: string;
	port: string;
	preserve_vndr_drid: string;
	security_card_no: string;
	service_authorization: string;
	tax_id_type: string;
	tch_contract1: number;
	tch_contract10: number;
	tch_contract2: number;
	tch_contract3: number;
	tch_contract4: number;
	tch_contract5: number;
	tch_contract6: number;
	tch_contract7: number;
	tch_contract8: number;
	tch_contract9: number;
	tch_contract_url: string;
	tchws_client_id: string;
	tchws_last_login: Date;
	tractor_hub_setting: string;
	tractor_hub_validate: string;
	tractor_setting: string;
	tractor_validate: string;
	trans_ip_address: string;
	transaction_port: string;
	trusted_cert_url: string;
	update_asset_status: string;
	update_card_status: string;
	update_disp_status: string;
	update_drvr_callin: string;
	update_drvr_status: string;
	update_equip_id: string;
	update_order_id: string;
	validation_type: string;
	vru_access: string;
}

